export default "__VITE_ASSET__CJr0iBDS__"